<template>
	<div>
		<div style="display: flex;margin-bottom: 20px;">
			<!-- 选择门店 -->
			<el-select @change="getlist" style="width:120px;margin-right: 10px;" class="jul" size="small"
				v-model="filter.time" placeholder="请选择时间">
				<el-option v-for="item in storeval" :key="item.value" :label="item.label"
					:value="item.value"></el-option>
			</el-select>
			<el-date-picker value-format="yyyy/MM/dd HH:mm:ss" @change="getlist" v-if="filter.time == 0" size="small"
				v-model="filter.times" type="datetimerange" range-separator="至" start-placeholder="开始日期"
				end-placeholder="结束日期">
			</el-date-picker>
		</div>
		<div>
			<el-table :cell-style="{ 'text-align': 'center' }"
				:header-cell-style="{ background: '#F2F2F4', 'text-align': 'center' }" ref="multipleTable"
				:data="tableData" tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="orderNo" label="订单编号"> </el-table-column>
				<el-table-column prop="type" label="商品/服务"> </el-table-column>
				<el-table-column label="订单类型">
					<template slot-scope="scope">
						{{ scope.row.orderType ? scope.row.orderType : "无" }}
					</template>
				</el-table-column>
				<el-table-column prop="lineUpTime" label="排队时长"> </el-table-column>
				<el-table-column prop="storeName" label="服务门店"> </el-table-column>
				<el-table-column label="地址">
					<template slot-scope="scope">
						{{ scope.row.caddress ? scope.row.caddress : "无" }}
					</template>
				</el-table-column>
				<el-table-column prop="workerName" label="发型师"> </el-table-column>
				<el-table-column label="支付总额">
					<template slot-scope="scope">
						￥{{ scope.row.payMoney ? scope.row.payMoney : 0 }}
					</template>
				</el-table-column>
				<el-table-column label="评价等级">
					<template slot-scope="scope">
						{{ scope.row.commentScore }}
					</template>
				</el-table-column>
				<el-table-column prop="addTime" label="评论时间"> </el-table-column>
				<el-table-column width="130" label="操作">
					<div>
						<el-button type="text">详情</el-button>
					</div>
				</el-table-column>
			</el-table>
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="filter.page" :page-sizes="[5, 10, 15, 20]" :page-size="filter.size"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				total: 0,
				filter: {
					endTime: "",
					startTime: "",
					time: "",
					page: 1,
					size: 10,
				},
				tableData: [],
				// tabs 数据列表
				tabs: [{
					id: 0,
					value: "门店管理",
					isActive: true,
				}, {
					id: 1,
					value: "加盟管理",
					isActive: false,
				}, {
					id: 2,
					value: "门店指标",
					isActive: false,
				}, ],
				//   tabs门店管理

				//筛选时间段
				timeVal: "",
				storeval: [{
					label: "昨天",
					value: "昨天",
				}, {
					label: "最近7天",
					value: "最近7天",
				}, {
					label: "最近30天",
					value: "最近30天",
				}, {
					label: "自定义",
					value: 0,
				}, ],
				// 选择状态
				stateVal: "",
				statelist: [{
					label: "状态",
					value: 1,
				}, {
					label: "正常营业",
					value: 2,
				}, {
					label: "门店撤店",
					value: 3,
				}, {
					label: "即将开业",
					value: 4,
				}, {
					label: "门店调休",
					value: 5,
				}, ],
				// 店铺名称
				storeName: "",
				currentPage4: 4,
				id: ''
			};
		},
		mounted() {
			this.id = this.$route.query.id;
			//获取列表
			this.getlist();
		},
		methods: {
			getlist() {
				if (this.filter.times) {
					var arr = {
						time: "自定义",
						size: this.filter.size,
						page: this.filter.page,
						endTime: this.filter.times[1],
						startTime: this.filter.times[0],
						userId: this.id
					};
				} else {
					var arr = {
						size: this.filter.size,
						page: this.filter.page,
						userId: this.id
					};
				}
				if (
					this.filter.time == "最近30天" ||
					this.filter.time == "最近7天" ||
					this.filter.time == "昨天"
				) {
					var arr = {
						size: this.filter.size,
						page: this.filter.page,
						time: this.filter.time,
						userId: this.id
					};
					this.filter.endTime = "";
					this.filter.startTime = "";
					this.filter.times = "";
				}
				this.$http
					.get("user/commentList", {
						params: arr
					}, {
						emulateJSON: true
					})
					.then(
						function(res) {
							if (res.body.code == 200) {
								console.log(res);
								this.tableData = res.body.data.list;
								this.total = res.body.data.total;
							}
						},
						function(err) {
							this.$message.error("请求失败");
						}
					);
			},
			handleSizeChange(val) {
				this.filter.size = val;
				this.getlist();
			},
			handleCurrentChange(val) {
				this.filter.page = val;
				this.getlist();
			},
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) =>
					i === id ? (v.isActive = true) : (v.isActive = false)
				);
			},
		},
	};
</script>
<style lang="less" scoped>
	.first_line {
		width: 100%;
		margin: 20px 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}
</style>